export default {
  bought: 'bought',
  history: 'history',
  certificat: 'certificat',
  favorits: 'favorits'
}
